import { Box, Button, Tooltip, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import React from 'react';

interface CustomerNameTagButtonProps {
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>;
  onInsert?: (newValue: string) => void;
}

const TAG = '{{nome_do_cliente}}';

const CustomerNameTagButton: React.FC<CustomerNameTagButtonProps> = ({ inputRef, onInsert }) => {

  const handleInsertTag = () => {
    const input = inputRef.current;
    if (!input) return;

    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    const currentValue = input.value;

    // Insere a tag na posição do cursor
    const newValue = currentValue.slice(0, start) + TAG + currentValue.slice(end);

    // Atualiza o valor (precisa disparar evento para react-admin captar)
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, 'value'
    )?.set;
    nativeInputValueSetter?.call(input, newValue);

    const event = new Event('input', { bubbles: true });
    input.dispatchEvent(event);

    // Move o cursor para depois da tag inserida
    setTimeout(() => {
      input.focus();
      input.setSelectionRange(start + TAG.length, start + TAG.length);
    }, 0);

    onInsert?.(newValue);
  };

  return (
    <Tooltip
      title={
        <Box sx={{ p: 1 }}>
          <Typography variant="subtitle2" gutterBottom>
            Personalização com nome do cliente
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Use <code>{'{{nome_do_cliente}}'}</code> para incluir o primeiro nome do cliente na mensagem.
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Exemplo:
          </Typography>
          <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
            "Olá {'{{nome_do_cliente}}'}, temos uma oferta especial!"
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: 'grey.300' }}>
            → Usuário "João" recebe: "Olá João, temos uma oferta especial!"
          </Typography>
        </Box>
      }
      arrow
      placement="top"
    >
      <Button
        variant="outlined"
        size="small"
        startIcon={<PersonIcon />}
        onClick={handleInsertTag}
        sx={{ ml: 1, textTransform: 'none' }}
      >
        Adicionar nome do cliente
      </Button>
    </Tooltip>
  );
};

export default CustomerNameTagButton;
